"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyUpload = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const EmptyUploadSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 120 120",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#empty-upload__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#CFCEFD",
      d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      d: "M36.006 95A2.01 2.01 0 0 1 34 92.997V33.003A2 2 0 0 1 35.998 31h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2 2 0 0 1 77.994 95z",
      opacity: 0.35
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      d: "M42.006 89A2.01 2.01 0 0 1 40 86.997V27.003A2 2 0 0 1 41.998 25h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2 2 0 0 1 83.994 89z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "#665AF4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M63 74.25v-22.5M73.5 62.25 63 51.75l-10.5 10.5"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      d: "M85 41H70V26z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M83.994 89A2 2 0 0 0 86 87.003V41.001c0-.553-.313-1.314-.703-1.704L71.703 25.703c-.388-.388-1.141-.703-1.7-.703H41.999A2.006 2.006 0 0 0 40 27.003v59.994c0 1.106.898 2.003 2.006 2.003zm-.99-2H42.996a.997.997 0 0 1-.997-.991V27.99c0-.547.447-.991.995-.991h26.06l-.048 13.008A1.984 1.984 0 0 0 70.992 42H84v43.997A1 1 0 0 1 83.003 87M72.001 40A1.007 1.007 0 0 1 71 38.998v-9.995c0-.547.316-.687.706-.297l10.588 10.588c.385.385.257.706-.296.706z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "empty-upload__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h120v120H0z"
      })
    })
  })]
});
const EmptyUpload = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: EmptyUploadSvg
}));
exports.EmptyUpload = EmptyUpload;